import { render, staticRenderFns } from "./r-worker-kind-dropdown.vue?vue&type=template&id=f8a2f906"
import script from "./r-worker-kind-dropdown.vue?vue&type=script&lang=js"
export * from "./r-worker-kind-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8a2f906')) {
      api.createRecord('f8a2f906', component.options)
    } else {
      api.reload('f8a2f906', component.options)
    }
    module.hot.accept("./r-worker-kind-dropdown.vue?vue&type=template&id=f8a2f906", function () {
      api.rerender('f8a2f906', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/worker-kind/r-worker-kind-dropdown.vue"
export default component.exports